

























































































import Vue from 'vue';
import StatsService from '@/api/stats.service';
import EventBus from '@/helpers/event-bus';
import { dunningCampaignOutcomeMap, LOAD_STATE } from '@/store/shared';
import { IReactivationStats, ISession, LoadState, IDunningCampaignCount } from '@/store/types';
import { formatPercent, formatSmallMoney, formatSmallNumber } from '@/helpers/jsUtils';
import { shortTimeAgoExtended } from '@/helpers/date-utils';
import OverallLoader from '@/components/UI/Loader/OverallLoader.vue';
import HeaderLoader from '@/components/UI/Loader/HeaderLoader.vue';
import { mapGetters, mapState } from 'vuex';
import { timeDay } from 'd3';

export default Vue.extend({
  name: 'OvervallPerformance',
  components: {
    HeaderLoader,
    OverallLoader,
  },
  data() {
    return {
      reactivationRates: null as IReactivationStats | null,
      loadState: LOAD_STATE.LOADING as LoadState,
      LOAD_STATE,
      formatSmallMoney,
      formatPercent,
      formatSmallNumber,
      shortTimeAgoExtended,
      activeCampaigns: 0,
      activeCampaignAmount: 0,
      totalRecoveredAmount: 0,
      totalCampaignsRecovered: 0,
      cleanCampaigns: 0,
      cleanCampaignsRecovered: 0,
      recoveredLastWeek: 0,
      emailsSentLastWeek: 0,
      emailsOpenedLastWeek: 0,
      recentRecoveryDate: undefined as undefined | Date,
      recentRecoveryAmount: 0,
      recentRecoveryName: '',
      recentRecoveryCurrency: undefined as undefined | string,
      outcomeBreakdown: {} as { [key: string]: number },
      dunningCampaignOutcomeMap,
    };
  },
  async created() {
    try {
      const dateLastWeek = timeDay.floor(timeDay.offset(new Date(), -7));
      const [active, total, outcomes, cleanRecovery, lastWeek, lastWeekEmails, recentSuccess] = await Promise.all([
        StatsService.dunningCampaignCountUsd({
          filter: { active: true },
        }),
        StatsService.dunningCampaignCountUsd({
          filter: { active: false },
          breakdown: ['recovered'],
        }),
        StatsService.dunningCampaignCountUsd({
          filter: { active: false },
          breakdown: ['outcome'],
        }),
        StatsService.dunningCampaignCountUsd({
          filter: { active: false, '-inherited': true, '-trial': true },
          breakdown: ['recovered'],
        }),
        StatsService.dunningCampaignCountUsd({
          filter: { recovered: true, startDate: dateLastWeek },
        }),
        StatsService.dunningEmailCounts({
          filter: { startDate: dateLastWeek, isDelivered: true },
          breakdown: ['isOpened'],
        }),
        StatsService.filteredDunningCampaigns({
          filter: { active: false, recovered: true },
          options: { limit: 1, sort: '-recoverDate', skip: 0 },
        }),
      ]);
      if (active && active.length) {
        this.activeCampaigns = active.reduce((acc, curr) => acc + curr.count, 0);
        this.activeCampaignAmount = active.reduce((acc, curr) => acc + curr.invoiceAmountUsd, 0);
      }
      if (total && total.length) {
        this.totalRecoveredAmount = total.reduce((acc, curr) => acc + curr.recoveredAmountUsd, 0);
        this.totalCampaignsRecovered = total.reduce((acc, curr) => acc + (curr.recovered ? curr.count : 0), 0);
      }
      if (outcomes && outcomes.length) {
        this.outcomeBreakdown = outcomes.reduce((acc, curr) => {
          acc[curr.outcome] = curr.recoveredAmountUsd;
          return acc;
        }, {} as { [key: string]: number });
      }
      if (cleanRecovery && cleanRecovery.length) {
        this.cleanCampaigns = cleanRecovery.reduce((acc, curr) => acc + curr.count, 0);
        this.cleanCampaignsRecovered = cleanRecovery.reduce((acc, curr) => acc + (curr.recovered ? curr.count : 0), 0);
      }
      if (lastWeek && lastWeek.length) {
        this.recoveredLastWeek = lastWeek.reduce((acc, curr) => acc + curr.recoveredAmountUsd, 0);
      }
      if (lastWeekEmails && lastWeekEmails.length) {
        this.emailsSentLastWeek = lastWeekEmails.reduce((acc, curr) => acc + curr.count, 0);
        this.emailsOpenedLastWeek = lastWeekEmails.reduce((acc, curr) => acc + (curr.isOpened ? curr.count : 0), 0);
      }
      if (recentSuccess && recentSuccess.length) {
        this.recentRecoveryDate = recentSuccess[0].recoverDate;
        this.recentRecoveryAmount = recentSuccess[0].amountRecovered || 0;
        this.recentRecoveryName = recentSuccess[0].customerEmail || '';
        this.recentRecoveryCurrency = recentSuccess[0].invoice?.currency;
      }
      this.loadState = LOAD_STATE.LOADED;
      EventBus.$emit('dashboard-overall-loaded');
    } catch (e) {
      console.log(e);
      this.loadState = LOAD_STATE.ERROR_LOADING;
    }
  },
  computed: {
    ...mapGetters(['lowData', 'daysSinceOrgCreated', 'confidential']),
    sessions(): ISession[] {
      return this.$store.state.recentSessions;
    },
    loading(): boolean {
      return this.$store.state.recentSessionsLoadState !== LOAD_STATE.LOADED;
    },
    lowVolume(): boolean {
      return this.lowData || this.daysSinceOrgCreated < 45;
    },
  },
});
